var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { API_PATH } from '../../constants';
import { action, observable, runInAction, makeObservable } from 'mobx';
import { getAxios } from '../../backend';
import { EventName, MESSAGE_DIRECTION, isTextMessage, isMediaMessage, isSpecialMessage, isContactsMessage, isLocationMessage, isRegularMessage } from '@whatsper/texterchat-common';
import moment from 'moment';
import { message } from 'antd';
import i18n from '../../i18n';
import { downloadFileFromString } from '../../helpers/file';
class ExportsStore {
    constructor(rootStore) {
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "exports", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable([])
        });
        Object.defineProperty(this, "loading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "validationProblems", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "getChatExports", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => __awaiter(this, void 0, void 0, function* () {
                runInAction(() => {
                    this.loading = true;
                });
                yield getAxios()
                    .then((axios) => {
                    return axios.get(`${API_PATH.EXPORT}`);
                })
                    .then(({ data }) => {
                    runInAction(() => {
                        this.exports.replace(data.exports);
                    });
                })
                    .catch((error) => {
                    console.error('Error on fetching chat exports', error);
                })
                    .finally(() => {
                    runInAction(() => {
                        this.loading = false;
                    });
                });
            })
        });
        Object.defineProperty(this, "validateExport", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (request) => __awaiter(this, void 0, void 0, function* () {
                return yield getAxios()
                    .then((axios) => {
                    return axios.post(`${API_PATH.EXPORT}/validate`, request);
                })
                    .then(({ data }) => {
                    if ('problems' in data) {
                        this.setValidationError(data.problems);
                        return false;
                    }
                    this.setValidationError([]);
                    return true;
                })
                    .catch((error) => {
                    console.error('Error on validating chat export', error);
                    message.error(error.message || i18n.t('unexpectedError'));
                    return false;
                });
            })
        });
        Object.defineProperty(this, "createChatExport", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (request) => __awaiter(this, void 0, void 0, function* () {
                runInAction(() => {
                    this.loading = true;
                });
                return getAxios()
                    .then((axios) => {
                    return axios.post(`${API_PATH.EXPORT}`, request);
                })
                    .then(({ data }) => {
                    if ('problems' in data) {
                        this.setValidationError(data.problems);
                        return false;
                    }
                    if ('exportEntityId' in data) {
                        return true;
                    }
                })
                    .catch((error) => {
                    console.error('Error on creating chat export', error);
                    message.error(error.message || i18n.t('unexpectedError'));
                })
                    .finally(() => {
                    runInAction(() => {
                        this.loading = false;
                    });
                });
            })
        });
        Object.defineProperty(this, "getChatExport", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (exportId) => __awaiter(this, void 0, void 0, function* () {
                runInAction(() => {
                    this.loading = true;
                });
                return getAxios()
                    .then((axios) => {
                    return axios.get(`${API_PATH.EXPORT}/${exportId}`);
                })
                    .then(({ data }) => {
                    return data;
                })
                    .catch((error) => {
                    console.error('Error on fetching chat export', error);
                })
                    .finally(() => {
                    runInAction(() => {
                        this.loading = false;
                    });
                });
            })
        });
        Object.defineProperty(this, "deleteChatExport", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (exportId) => __awaiter(this, void 0, void 0, function* () {
                runInAction(() => {
                    this.loading = true;
                });
                return getAxios()
                    .then((axios) => {
                    return axios.delete(`${API_PATH.EXPORT}/${exportId}`);
                })
                    .then(({ data }) => {
                    return data.success;
                })
                    .catch((error) => {
                    console.error('Error on deleting chat export', error);
                    message.error(error.message || i18n.t('unexpectedError'));
                })
                    .finally(() => {
                    runInAction(() => {
                        this.loading = false;
                    });
                });
            })
        });
        Object.defineProperty(this, "exportSingleChatHistory", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (chatId) => __awaiter(this, void 0, void 0, function* () {
                runInAction(() => {
                    this.loading = true;
                });
                try {
                    const { messages } = yield getAxios()
                        .then((axios) => {
                        return axios.get(API_PATH.MESSAGES, {
                            params: {
                                chatId,
                                limit: 1000, // max limit
                            },
                        });
                    })
                        .then(({ data }) => data);
                    const currentUser = this.rootStore.loginStore.userDetails;
                    const currentChat = this.rootStore.activeChatStore.chat;
                    const agentName = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.displayName) || (currentUser === null || currentUser === void 0 ? void 0 : currentUser.email) || 'Agent';
                    const formattedMessages = messages
                        .filter((msg) => !msg.systemMessage) // Skip system messages
                        .map((msg) => {
                        var _a, _b, _c;
                        const timestamp = moment(msg.timestamp).format('YYYY-MM-DD HH:mm:ss');
                        const userName = (currentChat && msg.direction === MESSAGE_DIRECTION.IN)
                            ? currentChat.title || 'Customer'
                            : agentName;
                        let messageText = '';
                        if (isTextMessage(msg)) {
                            messageText = msg.text || '';
                        }
                        else if (isMediaMessage(msg)) {
                            const mediaFiles = ((_a = msg.media) === null || _a === void 0 ? void 0 : _a.map((m) => {
                                const fileName = m.filename || m.fileId || 'file';
                                return `<attached ${fileName}>`;
                            }).join(' ')) || '<attached file>';
                            messageText = mediaFiles;
                            if ((_c = (_b = msg.media) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.caption) {
                                messageText += ` ${msg.media[0].caption}`;
                            }
                        }
                        else if (isSpecialMessage(msg)) {
                            messageText = msg.text || '[Special Message]';
                        }
                        else if (isContactsMessage(msg)) {
                            messageText = `[Contact Card] ${msg.contacts.map((c) => c.name).join(', ')}`;
                        }
                        else if (isLocationMessage(msg)) {
                            messageText = `[Location] ${msg.location.latitude}, ${msg.location.longitude}`;
                        }
                        else {
                            // always try to default to 'text' if available
                            messageText = (isRegularMessage(msg) && msg.text) || `[${msg.type}]`;
                        }
                        // Replace newlines in message text to keep one message per line
                        messageText = messageText.replace(/\n/g, ' ↵ ');
                        return `[${timestamp}] ${userName}: ${messageText}`;
                    })
                        .join('\n');
                    const safeTitle = ((currentChat === null || currentChat === void 0 ? void 0 : currentChat.title) || 'chat').replace(/\s+/g, '-').replace(/[^a-zA-Z0-9-_]/g, '');
                    const fileName = `chat-export-${safeTitle}-${moment().format('YYYY-MM-DD')}.txt`;
                    const downloaded = downloadFileFromString(formattedMessages, fileName, 'text/plain;charset=utf-8');
                    return downloaded;
                }
                catch (error) {
                    console.error('Error exporting chat', error);
                    return false;
                }
                finally {
                    runInAction(() => {
                        this.loading = false;
                    });
                }
            })
        });
        Object.defineProperty(this, "generateConnectionSpeedReportCSV", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (testFiles, connectionInfo, averageSpeed, individualTestResults, averagedPerformanceMetrics, sumOfIndividualDurations) => {
                const agent = this.rootStore.loginStore.userDetails;
                const lines = [];
                const reportTimestamp = moment().format('YYYY-MM-DD HH:mm:ss');
                let agentName = 'Unknown';
                if (agent) {
                    if (agent.displayName) {
                        agentName = `${agent.displayName} (${agent.email})`;
                    }
                    else if (agent.email) {
                        agentName = agent.email;
                    }
                }
                const headers = [
                    'Report Timestamp',
                    'Agent',
                    'Test File Name',
                    'Test File Declared Size (Bytes)',
                    'Connection: Effective Type',
                    'Connection: Downlink (Mbps)',
                    'Connection: RTT (ms)',
                    'Connection: Save Data',
                    'File: Download Speed (Mbps)',
                    'File: Download Duration (s)',
                    'File: Error',
                    'Overall Average Speed (Mbps)',
                    'Avg. API: Duration (ms)',
                    'Avg. API: TCP Handshake (ms)',
                    'Avg. API: DNS Lookup (ms)',
                    'Avg. API: TTFB (ms)',
                    'Total Download Duration (s)',
                ];
                lines.push(headers.map(h => this.escapeCsvValue(h)).join(','));
                // Add data rows
                testFiles.forEach((file, index) => {
                    var _a, _b, _c, _d, _e;
                    const result = individualTestResults[index] || { speed: null, duration: null, error: null };
                    const row = [
                        reportTimestamp,
                        agentName,
                        file.name,
                        file.size,
                        (connectionInfo === null || connectionInfo === void 0 ? void 0 : connectionInfo.effectiveType) || 'N/A',
                        (connectionInfo === null || connectionInfo === void 0 ? void 0 : connectionInfo.downlink) || 'N/A',
                        (connectionInfo === null || connectionInfo === void 0 ? void 0 : connectionInfo.rtt) || 'N/A',
                        (connectionInfo === null || connectionInfo === void 0 ? void 0 : connectionInfo.saveData) !== undefined ? (connectionInfo.saveData ? 'Yes' : 'No') : 'N/A',
                        result.speed || 'N/A',
                        ((_a = result.duration) === null || _a === void 0 ? void 0 : _a.toFixed(3)) || 'N/A',
                        result.error || 'N/A',
                        averageSpeed || 'N/A',
                        ((_b = averagedPerformanceMetrics === null || averagedPerformanceMetrics === void 0 ? void 0 : averagedPerformanceMetrics.duration) === null || _b === void 0 ? void 0 : _b.toFixed(2)) || 'N/A',
                        ((_c = averagedPerformanceMetrics === null || averagedPerformanceMetrics === void 0 ? void 0 : averagedPerformanceMetrics.tcpHandshake) === null || _c === void 0 ? void 0 : _c.toFixed(2)) || 'N/A',
                        ((_d = averagedPerformanceMetrics === null || averagedPerformanceMetrics === void 0 ? void 0 : averagedPerformanceMetrics.dnsLookup) === null || _d === void 0 ? void 0 : _d.toFixed(2)) || 'N/A',
                        ((_e = averagedPerformanceMetrics === null || averagedPerformanceMetrics === void 0 ? void 0 : averagedPerformanceMetrics.ttfb) === null || _e === void 0 ? void 0 : _e.toFixed(2)) || 'N/A',
                        (sumOfIndividualDurations === null || sumOfIndividualDurations === void 0 ? void 0 : sumOfIndividualDurations.toFixed(1)) || 'N/A',
                    ];
                    lines.push(row.map(r => this.escapeCsvValue(r)).join(','));
                });
                return lines.join('\n');
            }
        });
        Object.defineProperty(this, "setValidationError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (problems) => {
                this.validationProblems = problems;
            }
        });
        makeObservable(this);
        this.rootStore = rootStore;
        this.rootStore.events
            .addListener(EventName.export_created, (data) => this.onExportCreatedEvent(data))
            .addListener(EventName.export_deleted, (data) => this.onExportDeletedEvent(data))
            .addListener(EventName.export_updated, (data) => this.onExportUpdatedEvent(data));
    }
    escapeCsvValue(value) {
        if (value === null || value === undefined) {
            return '';
        }
        let stringValue = String(value);
        if (stringValue.search(/[",\n\r]/) >= 0) {
            stringValue = '"' + stringValue.replace(/"/g, '""') + '"';
        }
        return stringValue;
    }
    onExportCreatedEvent(data) {
        this.exports.unshift(data);
    }
    onExportDeletedEvent(data) {
        const item = this.exports.find((e) => e._id === data._id);
        if (item) {
            this.exports.remove(item);
        }
    }
    onExportUpdatedEvent(data) {
        this.exports.replace(this.exports.map((e) => {
            return e._id === data._id ? data : e;
        }));
    }
}
__decorate([
    observable
], ExportsStore.prototype, "exports", void 0);
__decorate([
    observable
], ExportsStore.prototype, "loading", void 0);
__decorate([
    observable
], ExportsStore.prototype, "validationProblems", void 0);
__decorate([
    action
], ExportsStore.prototype, "getChatExports", void 0);
__decorate([
    action
], ExportsStore.prototype, "validateExport", void 0);
__decorate([
    action
], ExportsStore.prototype, "createChatExport", void 0);
__decorate([
    action
], ExportsStore.prototype, "getChatExport", void 0);
__decorate([
    action
], ExportsStore.prototype, "deleteChatExport", void 0);
__decorate([
    action
], ExportsStore.prototype, "exportSingleChatHistory", void 0);
__decorate([
    action
], ExportsStore.prototype, "generateConnectionSpeedReportCSV", void 0);
__decorate([
    action
], ExportsStore.prototype, "setValidationError", void 0);
__decorate([
    action
], ExportsStore.prototype, "onExportCreatedEvent", null);
__decorate([
    action
], ExportsStore.prototype, "onExportDeletedEvent", null);
__decorate([
    action
], ExportsStore.prototype, "onExportUpdatedEvent", null);
export default ExportsStore;
